const { createSlice } = require('@reduxjs/toolkit');

const policySlice = createSlice({
    name: "policy",
    initialState: {
        policyName: "",
        
    },
    reducers: {
        setpolicy(state, action) {
            const policyName = action.payload;

            return state = {
                policyName
            };
            
           
        }
    },
});

export const { setpolicy } = policySlice.actions;
export default policySlice.reducer;
